import { Injector, Pipe, PipeTransform } from '@angular/core';
import { FormElementRegistry, ViewRuleRegistry, IFieldViewRule } from '@farris/devkit';

@Pipe({ name: 'elementRequired' })
export class ElementRequiredPipe implements PipeTransform {
  constructor(private injector: Injector, private formElementRegistry: FormElementRegistry, private viewRuleRegistry: ViewRuleRegistry) { }
  transform(value: any, elementId: string, version: any) {
    if (!this.formElementRegistry || !this.viewRuleRegistry) {
      return value;
    }
    // è·ååç´ éç½®
    const viewElement = this.formElementRegistry.getElementById(elementId);
    if (!viewElement) {
      return value;
    }
    const binding = viewElement.binding;
    // è·åçé¢è§å
    const viewRule = this.viewRuleRegistry.getRuleById(binding) as IFieldViewRule;
    // åç«¯æªéç½®çé¢è§å
    if (!viewRule) {
      return value;
    }
    // è·åå°äºåç«¯è§å
    const ruleRequired = viewRule.required;
    if (typeof ruleRequired !== 'boolean') {
      // æ æè§å
      return value;
    }
    // const configRule = viewElement.rules.find((rule: IFormRule) => rule.type === Farris.FormRule.RuleType.Required);
    // å¦æè§åæ¯éå¿å¡«ï¼å³è§åä¸­æ²¡æéå¶å¿å¡«ï¼ä¸å¤çï¼ä»¥è¡¨åéç½®ä¸ºå
    if (!ruleRequired) {
      return value;
    }
    return true;
  }
}
